export const CREATE_LANDING_ACTION = '[Landing Action] Create Landing';
export const CONFIRMED_CREATE_LANDING_ACTION = '[Landing Action] Confirmed Create Landing';
export const CREATE_LANDING_ERROR_ACTION = '[Landing Action] Create Landing Error';
export const GET_LANDINGS = '[Landing Action] Get Landings';
export const CONFIRMED_GET_LANDINGS = '[Landing Action] Confirmed Get Landings';
export const LOADING_LANDINGS = '[Landing Action] Loading for Landings';
export const EDIT_LANDING_ACTION = '[Landing Action] Edit Landing';
export const CONFIRMED_EDIT_LANDING_ACTION = '[Landing Action] Confirmed Edit Landing';
export const DELETE_LANDING_ACTION = '[Landing Action] Delete Landing';
export const CONFIRMED_DELETE_LANDING_ACTION = '[Landing Action] Confirmed Delete Landing';
export const LANDING_ERROR_ACTION = '[Landing Action] Error';
export const CLEAR_LANDING_ERROR = '[Landing Action] Clear Error';




